import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSelectWrapper } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import {
  getFrequencyPeriodLabel,
  getFrequencyPeriodOptions,
} from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/FrequencyPeriodSelect/FrequencyPeriodSelect.utils';

export interface FrequencyPeriodSelectProps {
  name: string;
  id: string;
  disabled?: boolean;
}

export function FrequencyPeriodSelect({
  name,
  id,
  disabled,
}: FrequencyPeriodSelectProps): JSX.Element {
  const { control, errors, watch } = useFormContext();
  const frequency = watch('frequency');
  const label = getFrequencyPeriodLabel(frequency);
  const options = getFrequencyPeriodOptions(frequency);

  return (
    <CookbookSelectWrapper
      label={label}
      name={name}
      id={id}
      disabled={disabled}
      options={options}
      error={errors[name]}
      control={control}
      blockWidth
    />
  );
}
